import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SCHOLARSHIP_PAYMENT_FEATURE_KEY,
  ScholarshipPaymentState,
  ScholarshipPaymentPartialState,
  scholarshipPaymentAdapter,
} from './scholarship-payment.reducer';
import { ScholarshipPaymentDto } from '@cradua/data';

// Lookup the 'ScholarshipPayment' feature state managed by NgRx
export const getScholarshipPaymentState = createFeatureSelector<
  ScholarshipPaymentPartialState,
  ScholarshipPaymentState
>(SCHOLARSHIP_PAYMENT_FEATURE_KEY);

const { selectAll, selectEntities } = scholarshipPaymentAdapter.getSelectors();

export const getScholarshipPaymentLoaded = createSelector(
  getScholarshipPaymentState,
  (state: ScholarshipPaymentState) => state.loaded
);

export const getScholarshipPaymentError = createSelector(
  getScholarshipPaymentState,
  (state: ScholarshipPaymentState) => state.error
);

export const loadingScholarshipPayment = createSelector(
  getScholarshipPaymentState,
  (state: ScholarshipPaymentState) => state.loaded
);

export const getAllScholarshipPayment = createSelector(
  getScholarshipPaymentState,
  (state: ScholarshipPaymentState) => selectAll(state)
);

export const getScholarshipPaymentEntities = createSelector(
  getScholarshipPaymentState,
  (state: ScholarshipPaymentState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getScholarshipPaymentState,
  (state: ScholarshipPaymentState) => state.selectedScholarshipPaymentId
);

export const getSelected = createSelector(
  getScholarshipPaymentEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllScholarshipPayment,
  getSelectedId,
  (users: ScholarshipPaymentDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter((user) =>
          user.StudentName.toLowerCase().includes(
            String(selectedId).toLowerCase()
          )
        )
);
